import React from "react";

import IntroSection from "./IntroSection";
import ServiceSection from "./ServiceSection";
import BeautySalonVideoSection from "./BeautySalonVideoSection";
import ReviewSection from "./ReviewSection";
import FAQsSection from "./FAQsSection";

const Home = () => {
  return (
    <>
      <IntroSection />
      <ServiceSection />
      <BeautySalonVideoSection />
      <ReviewSection />
      <FAQsSection />
    </>
  );
};

export default Home;
